"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var resolve_locale_code_1 = require("../utils/resolve-locale-code");
function formatNumber(locale, formatOptions, amount) {
    if (formatOptions === void 0) { formatOptions = {}; }
    if (typeof amount === 'number' && isNaN(amount)) {
        return '';
    }
    var code = resolve_locale_code_1.resolveLocaleCode(locale);
    try {
        Intl.NumberFormat.supportedLocalesOf([code]);
    }
    catch (error) {
        code = 'en-US';
    }
    var formatter = new Intl.NumberFormat(code, formatOptions);
    return formatter.format(Number(amount));
}
exports.default = formatNumber;
//# sourceMappingURL=format-number.js.map